import { PullToRefreshSpinner } from "@components/PullToRefresh/PullToRefreshSpinner";
import { getDevicePlatform, isStandalonePwa } from "@utils/environment";
import { h, render } from "preact";
import { useEffect } from "preact/compat";
import PullToRefresh from "pulltorefreshjs";

interface UsePullToRefreshOptions {
  mainElement?: string | HTMLElement;
  shouldPullToRefresh?: () => boolean;
  onRefresh: () => void | Promise<void>;
}

const getSpinnerHtml = (): string => {
  const tempDiv = document.createElement("div");
  render(h(PullToRefreshSpinner, {}), tempDiv);
  return tempDiv.innerHTML;
};

export const usePullToRefresh = ({
  mainElement = "body",
  shouldPullToRefresh,
  onRefresh,
}: UsePullToRefreshOptions) => {
  useEffect(() => {
    if (getDevicePlatform() !== "ios" || !isStandalonePwa()) {
      return undefined;
    }

    const spinnerHtml = getSpinnerHtml();

    const instance = PullToRefresh.init({
      mainElement,
      onRefresh,
      shouldPullToRefresh,
      passive: true,
      iconArrow: spinnerHtml,
      iconRefreshing: spinnerHtml,
      instructionsPullToRefresh: "",
      instructionsReleaseToRefresh: "",
      instructionsRefreshing: "",
    });

    return () => {
      instance.destroy();
    };
  }, [mainElement, shouldPullToRefresh, onRefresh]);
};
